import React from 'react';
import cn from 'classnames';
import classes from './build-a-box-cart-button.scss';
export default function BuildABoxCartButton({
  className,
  cartBuildABoxButtonLabel,
  shouldShowBuildABoxButton,
  disabled,
  onClick
}) {
  if (!shouldShowBuildABoxButton) {
    return null;
  }
  return /*#__PURE__*/React.createElement("button", {
    "data-button": "BuildABox",
    onClick: onClick,
    className: cn(classes.button, className),
    disabled: disabled
  }, /*#__PURE__*/React.createElement("span", null, cartBuildABoxButtonLabel));
}